<template>
  <div class="JSON-to-table" :style="style_variables" ref="root">
    <div class="paginator" :style="{'left':$store.getters.getSideNavigationWidth+'px'}" v-if="n_pages>1">
      <button @click="current_page=1" class="page" :class="{'grid-1':current_page>3,'grid-2':current_page===3,'grid-3':current_page===2}"  v-if="current_page>1">1</button>
      <div  class="page grid-2" v-if="current_page>3">...</div>
      <button  @click="current_page--" class="page grid-3" v-if="current_page>2">{{current_page - 1}}</button>
      <button disabled class="page grid-4" >{{current_page}}</button>
      <button @click="current_page++" class="page grid-5"  v-if="current_page<n_pages-1">{{current_page + 1}}</button>
      <div class="page grid-6"  v-if="current_page<n_pages-2">...</div>
      <button @click="current_page=n_pages" class="page grid-7"  v-if="current_page<n_pages">{{n_pages}}</button>
    </div>
    <div class="table" :style="table_style">
      <div class="annotate">
      </div>
      <div class="column-head item select" v-if="select">
        <Checkbox @change="selectAllRows($event)" :presetValue="original_index_of_selected_rows.size>=filter(data_with_original_index,search_string).length"/>
      </div>
      <div class="column-head item" v-for="column in columns_show" :key="column">
        <div class="head-name">{{column.name}}</div>

        <div class="head-sort" @click.prevent="handleSortClick(column)">
          <button class="icon-wrapper" :class="{active: JSON.stringify(sort_by_col?.id)==JSON.stringify(column?.id) && !sort_asc}">
            <ion-icon name="chevron-up-outline" ></ion-icon>
          </button>
          <button class="icon-wrapper" :class="{active: JSON.stringify(sort_by_col?.id)==JSON.stringify(column?.id) && sort_asc}">
            <ion-icon name="chevron-down-outline"></ion-icon>
          </button>
        </div>
        <button @click.prevent="toggleColFilter($event,column)" class="icon-wrapper col-filter-button" :class="{filtering: JSON.stringify(column?.id) in active_col_filters,active: active_modal_col_filter?.name && JSON.stringify(column?.id)==JSON.stringify(active_modal_col_filter?.id)}">
          <ion-icon name="chevron-down-outline"></ion-icon>
        </button>
      </div>
      <template v-if="loading">
        <DataPlaceholder />
      </template>
      <template v-else>
        <div @click="handleRowClick($event, row)" :ref="`row-${row[original_index_key]}`" :class="{'row-clicked':last_row_clicked?.[original_index_key]===row?.[original_index_key], 'row-highlight': highlight_by_id ? row_highlight==row.id : row_highlight==row[original_index_key]}" class="table-row" v-for="row in render_rows" :key="row">
          <div class="annotate" v-if="annotate">
            <template v-if="annotate_by_id">
              <div class="annotate-icon" v-if="row.id in annotate">{{annotate[row.id].length}}</div>
            </template>
            <template v-else>
              <div class="annotate-icon" v-if="row[original_index_key] in annotate">{{annotate[row[original_index_key]]}}</div>
            </template>
          </div>
          <div class="annotate" v-else></div>
          <div class="table-entry item select" :class="`state-${row.state}`" v-if="select">
            <Checkbox @change="selectRow($event, row)" :presetValue="original_index_of_selected_rows.has(row[original_index_key])"/>
          </div>
          <div class="table-entry item" :class="`state-${row.state}`" v-for="(column) in columns_show" :key="column" v-html="getEntry(row,column)"></div>
        </div>
      </template>
    </div>
    <dialog class="col-filter-dialog" ref="col_filter_dialog" :style="col_filter_dialog_style" >
      <template v-if="active_modal_col_filter?.id">
        <div class="col-filter-dialog-top-bar">
          <button class="close" @click.prevent="closeColFilterDialog">
            <ion-icon class="icon" name="close-outline"></ion-icon>
          </button>
        </div>
        <div class="col-filter-dialog-title">
          <Checkbox @change="setColFilterAll($event,active_modal_col_filter)" label="All" :presetValue="!(JSON.stringify(active_modal_col_filter?.id) in active_col_filters)"/>
        </div>
        <div class="col-filter-dialog-indv">
          <Checkbox @change="setColFilter($event,value,active_modal_col_filter)" :presetValue="!(JSON.stringify(active_modal_col_filter?.id) in active_col_filters) || !(active_col_filters[JSON.stringify(active_modal_col_filter?.id)]?.has(value))" v-for="value in getColValues(active_modal_col_filter)" :key="value" :label="String(value)"/>
        </div>
      </template>
    </dialog>
    <dialog ref="row_options" class="row-options" :style="row_options_style">
      <div class="row-options-window-bar">
        <button class="close" @click="closeRowmenu()">
          <ion-icon class="icon" name="close-outline"></ion-icon>
        </button>
      </div>
      <div class="row-options-body">
        <div class="option-wrapper" v-for="option in filterByPermission(row_options)" :key="option">
          <template v-if="awaiting_option.has(option.id)">
            <div class="awaiting-option-wrapper">
              <div class="awaiting-option">
                <DataPlaceholder/>
              </div>
            </div>

          </template>

          <template v-else>
            <div class="step step-1" v-if="!option.two_step || !(option.id in option_step) || option_step[option.id]===0">
              <button @click="handleRowOption(option, 0)">
                <ion-icon class="icon" :name="option.icon"></ion-icon>
                <span>{{option.text}}</span>
              </button>
            </div>
            <div class="step step-2" v-else>
              <button @click="handleRowOption(option, 1)">
                <ion-icon class="icon" name="checkmark-outline"></ion-icon>
                <span>Confirm</span>
              </button>
              <button @click="option_step[option.id]=0">
                <ion-icon class="icon" name="close-outline"></ion-icon>
                <span>Cancel</span>
              </button>
            </div>
          </template>

        </div>
      </div>
    </dialog>

  </div>
</template>

<script>
import Checkbox from '@/components/inputs_23/Checkbox.vue' 
import DataPlaceholder from '@/components/DataPlaceholder.vue'
// import TablePlaceholder from '@/components/table/TablePlaceholder.vue' 

export default {
  name: 'JSONToTable',
  components: {
    Checkbox,
    DataPlaceholder,
  },
  props: {
    // Array of table data each
    // Each entry is of the form {id1: val1, id2: val2, ...}
    // Each id uniquely identifies the column
    // Only values with an id corresponding to an id in the columns prop are displayed
    data: Array,

    // Array of the tables header
    // Columns are displayed in the order they are listed
    // id: [string,array[string]]identifyer to select entry from data rows
    // name: [string] name to be displayed in column header
    // show: [boolean] controlling if column is displayed or not
    // nested: [boolean] controlling if id is for nested data
    // Each entry is of the form {id: column_id, name: column_name, show: Boolean, nested: Boolean}
    columns: Array,

    // Show / Hide column for row selection
    select: {
      type: Boolean,
      default: false,
    },

    search_string: String,
    rows_per_page: {
      type: Number,
      default: 50,
    },
    row_options: {
      type: Array,
      default: ()=>[],
    },
    self_order: Boolean,
    dataset_permission: Number,
    loading: Boolean,
    highlight_by_id: Boolean, 
    annotate: Object,
    annotate_by_id: Boolean,
  },
  data() {
    return {
      style_variables: {
        '--row_bg_dark': '#f0f0f0',
        '--row_bg_dark_0': 'rgba(200, 252, 234, 0.4)',
        '--row_bg_dark_1': 'rgba(227, 158, 33, 0.3)',
        '--row_bg_dark_2': 'rgba(220, 53, 69, 0.2)',
        '--row_bg_light': 'inherit',
        '--row_bg_light_0': 'rgba(200, 252, 234, 0.4)',
        '--row_bg_light_1': 'rgba(227, 158, 33, 0.3)',
        '--row_bg_light_2': 'rgba(220, 53, 69, 0.2)',
        '--header_bg': '#e0e0e0',
        // '--from-top': 
        // '--from_left': this
      },
      original_index_of_selected_rows: new Set(),
      original_index_key: 'original_index',
      sort_by_col: null,
      sort_asc: true,

      current_page: 1,
      awaiting_option: new Set(),

      last_row_clicked: null,
      row_options_style: {
        'top': '0px',
        'left': '0px',
      },

      option_step: {},
      active_modal_col_filter: {},
      active_col_filters: {},
      active_col_position: {x:0,y:0,width:300},

      row_highlight: null,

    }
  },
  computed: {
    col_filter_dialog_style() {
      return {
        'max-width': this.active_col_position.width+'px',
        // 'top': 0+'px',
        // 'left': 0+'px',
        // 'left': `calc(-100% + ${this.active_col_position.x}px)`,
        'left': `${this.active_col_position.x}px`,
        'top': `${this.active_col_position.y}px`,
      }
    },
    table_placeholder_style() {
      const n_cols = this.columns_show.length + this.select
      console.log(n_cols)
      return {
        'grid-column-start': 1,
        'grid-column-end': n_cols+1,
      }
    },
    n_pages() {
      const n_pages = this.filter(this.data_with_original_index,this.search_string).length/this.rows_per_page
      if(n_pages%1!==0) {
        return Math.floor(n_pages) + 1
      }
      return Math.floor(n_pages)
    },
    data_with_original_index() {
      if(!this.data?.length) {
        return []
      }
      return this.data.map((row,index)=>{
        row[this.original_index_key] = index
        return row
      })
    },
    columns_show() {
      if(!this.columns?.length) {
        return []
      }
      return this.columns.filter(column=>column.show)
    },
    render_rows() {
      return this.page(this.sort(this.filter(this.filterByCol(this.data_with_original_index),this.search_string),this.sort_by_col,this.sort_asc),this.current_page,this.rows_per_page)
    },
    table_style() {
      const n_cols = this.columns_show.length + this.select
      return {
        'display': 'grid',
        'grid-template-columns': `15px repeat(${n_cols}, max-content)`,
      }
    },
  },
  watch: {
    $route(to,from) {
      this.setOrder({column_id:to.query.order_col,asc:to.query.order_asc==="true" ? true : false})
      if(to.query.highlight!=from.query.highlight) {
        this.row_highlight=to.query.highlight
      }
    },
  },
  mounted() {
    this.setOrder({column_id:this.$route.query.order_col,asc:this.$route.query.order_asc==="true" ? true : false})
    this.row_highlight=this.$route.query.highlight
  },
  methods: {
    closeColFilterDialog() {
      this.$refs.col_filter_dialog.close()
      this.active_modal_col_filter = null
      window.removeEventListener('click', this.windowClickHandler)
    },
    filterByCol(data) {
      return data.filter(row=>{
        var veto = false
        Object.keys(this.active_col_filters).forEach(col_id_string=>{
          const col_match = this.columns.find(col => JSON.stringify(col.id)===col_id_string)
          const value = this.getEntry(row,col_match)
          if(this.active_col_filters[col_id_string].has(value)) {
            veto = true
          }
        })
        return !veto
      })
      
    },
    setColFilterAll(checked,column) {
      if(checked) {
        delete this.active_col_filters[JSON.stringify(column.id)]
      } else {
        this.active_col_filters[JSON.stringify(column.id)] = this.getColValues(column)
      }
    },
    setColFilter(checked,value,column) {
      if(!checked) {
        if(!(JSON.stringify(column.id) in this.active_col_filters)) {
          this.active_col_filters[JSON.stringify(column.id)] = new Set([value])
        } else {
          this.active_col_filters[JSON.stringify(column.id)].add(value)
        }
      } else {
        if(JSON.stringify(column.id) in this.active_col_filters) {
          this.active_col_filters[JSON.stringify(column.id)].delete(value)
          if(this.active_col_filters[JSON.stringify(column.id)].size<=0) {
            delete this.active_col_filters[JSON.stringify(column.id)]
          }
        }
      }
    },
    getColValues(column) {
      return new Set(this.data.map(row=>this.getEntry(row,column)))
    },
    windowClickHandler(e) {
      if(!this.$refs.col_filter_dialog?.open) {
        this.$refs.col_filter_dialog?.show()
        return
      }
      const dialogDimensions = this.$refs.col_filter_dialog.getBoundingClientRect()
      if (
        e.clientX < dialogDimensions.left ||
        e.clientX > dialogDimensions.right ||
        e.clientY < dialogDimensions.top ||
        e.clientY > dialogDimensions.bottom
      ) {
        this.closeColFilterDialog()
      }
    },
    toggleColFilter(event,column) {
      if(JSON.stringify(column.id)===JSON.stringify(this.active_modal_col_filter?.id)) {
        return
      }
      this.closeColFilterDialog()
      window.addEventListener('click', this.windowClickHandler)
      const button_rect = event.target.getBoundingClientRect()
      const root_rect = this.$refs.root.getBoundingClientRect()
      const pos_x = button_rect.x-root_rect.x
      this.active_col_position.x = pos_x
      this.active_col_position.y = button_rect.height +  button_rect.y - root_rect.y
      if(button_rect.x+this.active_col_position.width>window.innerWidth) {
        this.active_col_position.x -= button_rect.x+this.active_col_position.width - window.innerWidth + 17
      }
      this.active_modal_col_filter = column
    },
    handleSortClick(column) {
      if(JSON.stringify(column.id)==JSON.stringify(this.sort_by_col?.id)) {
        this.sort_asc = !this.sort_asc
      } else {
        this.sort_by_col = column
      }
      this.$emit('order',{col:this.sort_by_col,asc:this.sort_asc})
    },
    setOrder({column_id,asc}) {
      this.sort_by_col = this.columns.find(column=>JSON.stringify(column.id)==column_id)
      this.sort_asc = asc ? true : false
    },
    setSelected(values) {
      this.original_index_of_selected_rows = new Set(values)
    },
    clearSelected() {
      this.original_index_of_selected_rows = new Set()
    },
    setPage(page) {
      this.current_page = page
    },
    filterByPermission(options) {
      return options.filter(option=>option?.permission<=this.last_row_clicked?.permission && !this.dataset_permission || option?.dataset_permission<=this.dataset_permission)
    },
    deSelectByIndex(index) {
      this.original_index_of_selected_rows.delete(index)
    },
    getSelectedSize() {
      return this.original_index_of_selected_rows.size
    },
    getSelected() {
      return this.data.filter(row=>this.original_index_of_selected_rows.has(row[this.original_index_key]))
    },
    handleRowOption(option, step) {
      if(option.two_step && step===0) {
        this.option_step[option.id] = 1
        return
      }
      this.$emit('option', {option, row:this.last_row_clicked,table:this})
      if(option.await) {
        this.awaiting_option.add(option.id)
      } else {
        this.closeRowmenu()
      }
    },
    closeRowmenu() {
      this.option_step = {}
      this.last_row_clicked = null
      this.$refs.row_options?.close()
      window.removeEventListener('click', this.windowClickHandlerRow)
    },
    windowClickHandlerRow(e) {
      if(!this.$refs.row_options?.open) {
        this.$refs.row_options?.show()
        return
      }
      const dialogDimensions = this.$refs.row_options.getBoundingClientRect()
      if (
        e.clientX < dialogDimensions.left ||
        e.clientX > dialogDimensions.right ||
        e.clientY < dialogDimensions.top ||
        e.clientY > dialogDimensions.bottom
      ) {
        this.closeRowmenu()
      }
    },
    handleRowClick(event, row) {
      this.closeRowmenu()
      var dom_element = event.target

      while(!dom_element.classList.contains('checkbox')) {
        if(dom_element.classList.contains('JSON-to-table') || dom_element.classList.contains('table-row') || dom_element.classList.contains('table-entry') || dom_element.classList.contains('table')) {
          break
        }
        dom_element = dom_element.parentNode
        return
      }
      const relative_anchor = this.$refs.row_options.parentNode.getBoundingClientRect()
      var offset = event.y - relative_anchor.y
      if(window.innerHeight<event.y + this.row_options.length*35.19+28) {
        offset = event.y - relative_anchor.y - (event.y + this.row_options.length*35.19+28 - innerHeight)
        if(this.$store.getters.getXActive) {
          offset = event.y - relative_anchor.y - (event.y + this.row_options.length*35.19+28 - innerHeight) - 17
        }
      }
      var offset_x = event.x - this.$store.getters.getSideNavigationWidth
      if(event.x + 244 > window.innerWidth) {
        offset_x -= event.x + 244 - window.innerWidth + 31
      }
      this.row_options_style.left = offset_x + 'px' 
      this.row_options_style.top = offset + 'px'
      this.last_row_clicked = row
      if(this.filterByPermission(this.row_options)?.length>0) {
        window.addEventListener('click', this.windowClickHandlerRow)
        // this.$refs.row_options.show()
      }
    },
    page(data,current_page,rows_per_page) {
      return data.slice((current_page-1)*rows_per_page,current_page*rows_per_page)
    },
    sort(data,column,sort_asc) {
      if(column===null || column===undefined || !this.self_order) {
        return data
      }
      return data.sort((a,b)=>{
        var entry_a = this.getEntry(a,column)
        var entry_b = this.getEntry(b,column)

        if(entry_a===null || entry_a===undefined) {
          return 2*sort_asc - 1
        }
        if(entry_b===null || entry_b===undefined) {
          return -(2*sort_asc - 1)
        }
        if(typeof entry_a!=='string') {
          entry_a = `${entry_a}` 
        }
        if(typeof entry_b!=='string') {
          entry_b = `${entry_b}` 
        }
        return entry_a.localeCompare(entry_b,undefined, {numeric: true,sensitivity:'base'})*(2*sort_asc - 1)
      })
    },
    escapeCharacters(string) {
      string=string.replace('[', '\\[')
      string=string.replace(']', '\\]')
      string=string.replace('.', '\\.')
      return string
    },
    filter(data,search_string) {
      return data.filter(row=>{
        if(this.original_index_of_selected_rows.has(row[this.original_index_key])) {
          return true
        }
        var veto_row = true
        this.columns.forEach(column=>{
          const entry = this.getEntry(row,column)
          if(search_string=='' || !search_string || (entry && `${entry}`.match(new RegExp(this.escapeCharacters(search_string), "i")))) {
            veto_row = false
          }
        })
        return !veto_row
      })
      // return data
    },
    selectAllRows(is_checked) {
      if(is_checked) {
        this.original_index_of_selected_rows = new Set(this.filter(this.data_with_original_index,this.search_string).map(row=>row.original_index))
        return
      }
      this.original_index_of_selected_rows = new Set()
    },
    selectRow(is_checked, row) {
      if(is_checked) {
        this.original_index_of_selected_rows.add(row[this.original_index_key])
        return
      }
      this.original_index_of_selected_rows.delete(row[this.original_index_key])
    },
    getEntry(row, column) {
      var value = ""
      if(column.nested && Array.isArray(column.id)) {
        value = row
        column.id.forEach(sub_id=>{
          if(value===null) {
            return
          }
          value = value[sub_id]
        })
      } else {
        value = row[column.id]
      }
      if(column.map) {
        // console.log(column.map)
        value = column.map(value)
      }

      return value
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'D:\\inetpub\\MPortal\\src\\_variables';
.annotate {
  .annotate-icon {
    width: 26px;
    border-radius: 4px;
    aspect-ratio: 16/11;
    background: $text_red;
    position: relative;
    left: -6px;
    top: -6px;
    color: white;
    display: flex;
    justify-content: center;
    font-size: 0.875rem;
    align-items: center;
    &::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      border: 6px solid transparent;
      border-top-color: $text_red;
      border-bottom: 0;
      border-right: 0;
    }
  }
}
.awaiting-option-wrapper {
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  .awaiting-option {
    transform: scale(0.37);
  }
}

.col-filter-dialog {
  z-index: 201;
  align-items: flex-start;
  margin: 0;
  border: 2px solid $text_dark;
  padding: 0;
  border-radius: 6px;
  .col-filter-dialog-top-bar {
    font-size: 24px;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
    border-bottom: 1px solid gray;
    .close {
      height: 24px;
      aspect-ratio: 24/16;
      cursor: pointer;
      &:hover {
        background-color: $text_red;
      }
    }
  }
  .col-filter-dialog-title {
    padding: 0.5rem 0.5rem;
  }
  .col-filter-dialog-indv {
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0 1rem 0.5rem 1rem;
  }
}
.JSON-to-table {
  position: relative;
}
.row-options {
  border: 2px solid black;
  outline: none;
  padding: 0;
  margin: 0;
  width: 244px;
  overflow: auto;
  border-radius: 6px;
  background-color: white;
  z-index: 201;
  .row-options-window-bar {
    display: flex;
    justify-content: flex-end;
    font-size: 24px;
    height: 24px;
    border-bottom: 1px solid gray;

    button {
      border-top-right-radius: 4px;
      width: 32px;
      height: 24px;
      display: flex;
      justify-content: center;
      cursor: pointer;
      align-items: center;
      &:hover {
        background-color: $text_red;
      }
    }
  }

  .row-options-body {
    .option-wrapper {
      padding: 0.1rem 0;
      .step-2 {
        display: grid;
        grid-template-columns: 1fr 1fr;
      }
      .step {
        button {
          width: 100%;
          display: flex;
          align-items:center;
          cursor: pointer;
          &:hover {
            background-color: $text_dark;
            color: white;
          }
          .icon {
            font-size: 32px;
          }
        }
        min-width: 240px;
      }
    }
  }
}
.paginator {
  position: sticky;
  width: 200px;
  left: var(--from_left);
  display: grid;
  grid-template-columns: repeat(7,32px);
  gap: 2px;
  button {
    cursor: pointer;
    border: 1px solid #ccc;
    border-radius: 4px;
    &:hover {
      &:not(:disabled) {
        background-color: #ddd;
      }
    }
  }
  .page {
    display: flex;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1;
    width: 32px;

  }
  .grid-1 {
    grid-column: 1/2;
  }
  .grid-2 {
    grid-column: 2/3;
  }
  .grid-3 {
    grid-column: 3/4;
  }
  .grid-4 {
    grid-column: 4/5;
    background-color: $kit_green;
    color: white;
  }
}
.column-head {
  position: sticky;
  top:38px;
  text-align: center;
  padding-top: .1rem;
  padding-bottom: .1rem;
  background-color: var(--header_bg);
  display: grid;
  grid-template-columns: auto 16px 32px;
  gap: .5rem;
  align-items: center;
  z-index: 11;
  .head-name {
    justify-self: flex-start;
  }
  .col-filter-button {
    border-radius: 4px;
    cursor: pointer;
    border: 1px solid $text_dark;
    display: flex;
    justify-content: center;
    align-items: center;
    aspect-ratio: 24/16;
    &:hover {
      background-color: rgba(0,0,0,0.1);
    }
    > * {
      pointer-events: none;
    }
    &.active {
      > * {
        // color: red;
        transform: rotate(180deg);
      }
    }
    &.filtering {
      background-color: $kit_green;
      color: white;
    }
  }
  .head-sort {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 32px;
    .icon-wrapper {
      cursor: pointer;
      height: 16px;
      color: #999;
    }
    .active {
      color: #000;
    }
  }
}

.table-row {
  position: relative;
  display: contents;
  &.row-highlight {
    >.table-entry {
      background-color: rgba(0, 135, 108,0.4) !important;
    }
  }

  &.row-clicked {
    >.table-entry {
      background-color: #f7e3bd !important;
    }
  }
  &:nth-child(2n) {
    >.table-entry {
      background-color: var(--row_bg_dark);
      &.state-0 {
        background-color: var(--row_bg_dark_0);
      }
      &.state-1 {
        background-color: var(--row_bg_dark_1);
      }
      &.state-2 {
        background-color: var(--row_bg_dark_2);
      }
      
    }
  }
  &:nth-child(2n+1) {
    >.table-entry {
      background-color: var(--row_bg_light);
      &.state-0 {
        background-color: var(--row_bg_light_0);
      }
      &.state-1 {
        background-color: var(--row_bg_light_1);
      }
      &.state-2 {
        background-color: var(--row_bg_light_2);
      }
    }
  }
}
.table-entry {
  max-width: 620px;
  text-align: left;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4; /* number of lines to show */
  padding-top: .1rem;
  padding-bottom: .1rem;
  font-size: 0.9rem;
  // display: flex;
  // align-items: center;

}
.item {
  padding-left: .5rem;
  padding-right: .5rem;
}

</style>